<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("conta-corrente") }}</h1>
                        <nav
                            class="breadcrumb"
                            aria-label="breadcrumbs"
                            v-if="cameFrom == 'route'"
                        >
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("vendas") }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("financeiro")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("conta-corrente")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="cameFrom != 'route'"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                !integracao &&
                                permissao.create &&
                                cameFrom == 'route'
                            "
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="showModalFlexManage = true"
                        >
                            {{ $t("adicionar-conta-corrente") }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="filters-bar mb-3">
                    <div class="filters-bar-form form-columns-fit">
                        <div class="columns">
                            <div class="column is-6">
                                <search-bar
                                    :clean="limparBusca"
                                    :onSearch="debouncedOnSearch"
                                    :tooltipLabel="$t('msg-campo-busca-n', {
                                            n: 'codigo',
                                        })"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    title="empresa"
                                    placeholder="selecione"
                                    :options="empresaSelect"
                                    v-model="empresaSelected"
                                    :loading="empresaLoading"
                                    @search="carregarEmpresa"
                                    multiple
                                    searchable
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    title="colaborador"
                                    placeholder="selecione"
                                    v-model="colaboradorSelected"
                                    :options="colaboradorList"
                                    :loading="colaboradorLoading"
                                    @search="carregarColaborador($event)"
                                    multiple
                                    searchable
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="filters-bar-actions">
                        <b-button
                            type="is-primary"
                            icon-right="settings"
                            @click="showFilter = !showFilter"
                            v-tippy 
                            :title="$t('selecao-campos')"
                        />
                    </div>
                </div>
                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <FlexListTable
                        :contasFlex="contasFlex"
                        :callShowModal="callShowModal"
                        :isMobile="isMobile"
                        :sortTable="sortTable"
                        :isEmpty="isEmpty"
                        :isLoading="isLoading"
                        :cameFrom="cameFrom"
                        :fields="fields"
                        @edit="$emit('edit', $event)"
                        @promptChangeSituacao="promptChangeSituacao"
                        @showFlexLancamentoModal="
                            (contaFlex) => {
                                flexSelected = contaFlex;
                                showModalFlexLancamentoManage = true;
                            }
                        "
                    />
                </div>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <b-modal :active.sync="showFilter">
                <div class="bg">
                    <Parametrizacao
                        @fecharModal="fecharModal"
                        :fields="fields"
                    />
                </div>
            </b-modal>
            <lateral-content v-model="showModalFlexManage">
                <FlexManage
                    class="pt-4"
                    v-if="showModalFlexManage"
                    cameFrom="FlexManage"
                    @saved="
                        carregarDados(pagination.currentPage);
                        showModalFlexManage = false;
                    "
                    @voltar="showModalFlexManage = false"
                />
            </lateral-content>
            <lateral-content v-model="showModalFlexLancamentoManage" compact>
                <FlexLancamentoManage
                    class="pt-4"
                    v-if="showModalFlexLancamentoManage"
                    :contaFlex="flexSelected"
                    @saved="
                        carregarDados(pagination.currentPage);
                        showModalFlexLancamentoManage = false;
                    "
                    @voltar="showModalFlexLancamentoManage = false"
                />
            </lateral-content>
        </div>
    </div>
</template>

<script>
import FlexService from "@/services/vendas/financeiro/FlexService.js";
import EmpresaService from "@/services/vendas/empresa/EmpresaService.js";
import ColaboradorService from "@/services/ColaboradorService.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import FlexListTable from "@/components/vendas/financeiro/flex/FlexListTable.vue";
import Parametrizacao from "@/components/vendas/financeiro/flex/modal/Parametrizacao.vue";
import FlexManage from "@/components/vendas/financeiro/flex/FlexManage.vue";
import FlexLancamentoManage from "@/components/vendas/financeiro/flex/FlexLancamentoManage.vue";

export default {
    name: "FlexList",

    components: {
        ContainerLoader,
        FlexListTable,
        FlexManage,
        FlexLancamentoManage,
        Parametrizacao,
    },

    props: {
        cameFrom: {
            type: String,
            default: "route",
        },
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("VEN_FLEX"),
            contasFlex: [],
            service: new FlexService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(
                this.$http,
                this.$router
            ),
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            showFilter: false,
            limparBusca: false,
            empresaSelect: [],
            empresaSelected: [],
            empresaLoading: false,
            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,
            // filtros
            filters: {
                queryFilter: "",
                column: "DATAHORAINC",
                order: "desc",
                situacao: 1,
                currentPage: 1,
                perPage: 10,
                empresaList: [],
                colaboradorList: [],
            },
            showModal: false,
            accessDenied: false,
            showModalFlexManage: false,
            showModalFlexLancamentoManage: false,
            flexSelected: null,
            showModalDelete: false,
            selected: null,
            fields: [
                {
                    key: "idVenFlexErp",
                    label: "codigo",
                    width: 80,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "nomeEmpresa",
                    label: "empresa",
                    width: null,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "nomeUsuario",
                    label: "colaborador",
                    width: null,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "saldoTotalLiberado",
                    label: "saldo-disponivel",
                    width: 150,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "saldoTotalBloqueado",
                    label: "saldo-bloqueado",
                    width: 155,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "valorMinimo",
                    label: "saldo-minimo",
                    width: 135,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "datahoraalt",
                    label: "data-hora-alteracao",
                    width: 175,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "situacao",
                    label: "operacao",
                    width: 170,
                    sortable: false,
                    visible: true,
                },
            ],
        };
    },
    created() {
        const customFields = localStorage.getItem("tabelaFlexPersonalizada");
        const customFieldsParsed = JSON.parse(customFields);
        if (customFieldsParsed) this.fields = customFieldsParsed;

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    watch: {
        colaboradorSelected() {
            this.carregarDados();
        },
        empresaSelected() {
            this.carregarDados();
        },
        fields: {
            handler: function (newValue) {
                localStorage.setItem(
                    "tabelaFlexPersonalizada",
                    JSON.stringify(newValue)
                );
            },
            deep: true,
        },
    },
    methods: {
        isMobile() {
            return window.innerWidth <= 760;
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        resetPagination() {
            this.pagination.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];
            this.pagination.resetPagination = true;
            this.pagination.currentPage = 1;
            this.carregarDados(1);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.queryFilter = this.removeToSearch(value);
            this.carregarDados(1);
        },
        promptChangeSituacao(flex) {
            this.isLoading = true;

            const { situacao, ...rest } = flex;

            const mappedFlexToSend = {
                situacao: Number(!situacao),
                ...rest,
            };

            this.service
                .updateSituacao(mappedFlexToSend)
                .then((_) => {
                    const msg = !situacao
                        ? this.$t("flex-ativado-sucesso")
                        : this.$t("flex-inativado-sucesso");

                    this.$root.showMessage("success", msg, true, false);
                })
                .catch((error) => {
                    const msg = this.$t("situacao-alterada-erro");

                    this.$root.showMessage("success", msg, true, false);
                })
                .finally((_) => {
                    this.carregarDados();
                    this.isLoading = false;
                });
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.fillFilter(currentPage);
            this.service
                .findAll(this.filters)
                .then(({ content, totalElements }) => {
                    this.pagination.totalRows = totalElements;

                    this.contasFlex = content;
                    this.isEmpty = this.contasFlex.length <= 0;
                })
                .catch((e) => {
                    this.contasFlex = [];
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        mapColaboradorList(response) {
            return response.content.map((m) => {
                return {
                    id: m.id,
                    label: m.nome,
                };
            });
        },
        fillFilter(currentPage = 1) {
            this.filters.empresaList = this.empresaSelected.map((e) => e.id);

            this.filters.colaboradorList = this.colaboradorSelected.map(
                (e) => e.id
            );

            this.filters.perPage = this.pagination.perPage;
            this.filters.currentPage = currentPage;
            this.filters.queryFilter = this.filters.queryFilter || "";

            if (this.filters.column == "codigo") {
                this.filters.column = "ven_idflexerp";
            }
        },
        timeoutCarregarDados(time = 600) {
            this.showFilter = false;
            setTimeout(() => {
                this.carregarDados();
                this.limparBusca = false;
            }, time);
        },
        callShowModal(uuid, titulo) {
            this.showModal = true;
        },
        carregarColaborador(query = null) {
            this.colaboradorLoading = true;
            query = this.isNull(query) ? ".*" : this.removeToSearch(query);

            this.colaboradorService
                .findListAssociated(query)
                .then(this.mapColaboradorList)
                .then((value) => {
                    if (value != null) {
                        this.colaboradorList = value;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.colaboradorLoading = false;
                });
        },
        carregarEmpresa(query) {
            query = this.isNull(query) ? ".*" : this.removeToSearch(query);

            this.empresaLoading = true;
            this.empresaService
                .findAllComboSituacao(4, query)
                .then((body) => {
                    if (body.content) {
                        this.empresaSelect = body.content.map((m) => {
                            return {
                                id: m.idempresa,
                                label:
                                    m.replicapda == 2
                                        ? "Inativo | " +
                                          m.nome +
                                          " - " +
                                          m.rsocial
                                        : m.nome + " - " + m.rsocial,
                                replicapda: m.replicapda,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar empresas.");
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        fecharModal() {
            this.showFilter = false;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
